if (typeof window.initWarehouseColors === 'undefined' || !window.warehouseColorsInitialized) {

  window.initWarehouseColors = () => {
    const variantPicker = document.querySelector('variant-picker');
    const variantDataScript = document.querySelector('#productVariants');

    if (!variantPicker || !variantDataScript) {
      return;
    }

    if (variantPicker.dataset.colorsInitialized) {
      return;
    }
    variantPicker.dataset.colorsInitialized = 'true';

    const variants = JSON.parse(variantDataScript.textContent);

    const updateAllButtonColors = () => {
      const optionBlocks = variantPicker.querySelectorAll('variant-button, variant-color');
      const currentlySelectedValues = Array.from(optionBlocks).map(block => block.querySelector('input:checked')?.value || null);

      optionBlocks.forEach((block, blockIndex) => {
        const labels = block.querySelectorAll('.m-product-option--node__label');

        labels.forEach(label => {
          const input = document.getElementById(label.getAttribute('for'));
          if (!input) return;

          const buttonValue = input.value;

          const matchedVariant = variants.find(variant => {
            if (variant.options[blockIndex] !== buttonValue) {
              return false;
            }
            for (let i = 0; i < currentlySelectedValues.length; i++) {
              if (i === blockIndex) continue;
              if (currentlySelectedValues[i] !== null && currentlySelectedValues[i] !== variant.options[i]) {
                return false;
              }
            }
            return true;
          });

          label.classList.remove('warehouse-mauri', 'warehouse-other');

          if (matchedVariant && matchedVariant.available) {
            const warehouse = matchedVariant.metafields.warehouse;
            if (warehouse === 'Mauri USA') {
              label.classList.add('warehouse-mauri');
            } else if (warehouse === 'USA Warehouse') { // Yahan warehouse ka naam check kar lain
              label.classList.add('warehouse-other');
            }
          }
        });
      });
    };

    variantPicker.addEventListener('change', updateAllButtonColors);
    updateAllButtonColors();
  };

  document.addEventListener('shopify:section:load', window.initWarehouseColors);
  window.initWarehouseColors();
  window.warehouseColorsInitialized = true;
}